import { getBuyerId } from 'dibs-cookie-jar';
import { fetchQuery, Environment } from 'react-relay';
import SV from 'server-vars';
import idx from 'idx';

import { showTradeEnrollmentAndStatusUpdate } from './tradeEnrollmentAndStatusUpdateAction';
import { tradeEnrollmentAndStatusUpdateQuery } from './tradeEnrollmentAndStatusUpdateQuery';
import { hasSeenEnrollmentAndStatusUpdate } from './helpers';

import {
    tradeEnrollmentAndStatusUpdateQuery as QueryType,
    tradeEnrollmentAndStatusUpdateQueryResponse,
} from './__generated__/tradeEnrollmentAndStatusUpdateQuery.graphql';

export const tradeTradeEnrollmentAndStatusUpdate = async ({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> => {
    const userId = getBuyerId(document.cookie);

    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isDesktop = SV.get('settings.isDesktop') || false;

    if (!userId || !isUserTypeTrade || !isDesktop || hasSeenEnrollmentAndStatusUpdate()) {
        return Promise.resolve(false);
    }

    const response: tradeEnrollmentAndStatusUpdateQueryResponse = await fetchQuery<QueryType>(
        relayEnvironment,
        tradeEnrollmentAndStatusUpdateQuery,
        {}
    );

    return idx(response, o => o.viewer.isEnrollmentAndStatusUpdateEnabled) || false;
};

export const tradeEnrollmentAndStatusUpdateConfig = {
    name: 'tradeEnrollmentAndStatusUpdate',
    rule: tradeTradeEnrollmentAndStatusUpdate,
    action: showTradeEnrollmentAndStatusUpdate,
    priority: 485,
};
